"use client";

import { useEffect, useState } from "react";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import useIsClient from "@/hooks/useIsClient";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const getCompany = useGetCompanyQuery();
  const isClient = useIsClient();
  const company = getCompany?.data?.result;

  const showScrollToTopButton =
    company?.theme?.settings?.show_scroll_to_top_button;

  useEffect(() => {
    if (!isClient) return;

    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    // Initial check in case the page is reloaded halfway down
    toggleVisibility();

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, [isClient]);

  const scrollToTop = () => {
    if (!isClient) return;
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isClient || !showScrollToTopButton) return null;

  return (
    <button
      type="button"
      aria-label="Scroll to top"
      onClick={scrollToTop}
      className={`scroll-to-top-btn ${isVisible ? "visible" : ""}`}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M12 19V6M12 6l-6 6M12 6l6 6"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default ScrollToTopButton;
